import React from 'react';
import {
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ManufacturerFormBreadcrumb = ({ steps, currentStep, className = '' }) => {
  const navigate = useNavigate();
  const { role } = useSelector((state) => state.authReducer.userData);
  // console.log('User Role:', role); // Add this line to check the role

  const handleNavigate = () => {
    console.log('Navigating to Dashboard');
    navigate(`/${role}/dashboard`); // Adjusted to ensure correct path
  };

  return (
    <div className={`${className} font-roboto`}>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink
            className="text-lg text-gray-700 font-semibold hover:text-darkerPurple cursor-pointer ease-in-out duration-150 transition-colors"
            onClick={handleNavigate}
          >
            Dashboard
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink className="text-lg font-semibold text-darkPurple hover:text-darkerPurple cursor-pointer ease-in-out duration-150 transition-colors">
            {currentStep === 7
              ? 'Add Plants'
              : currentStep === 8
                ? 'Add Machines'
                : currentStep === 9
                  ? 'Add Plants'
                  : currentStep === 10
                    ? 'Add Machines'
                    : steps[currentStep - 1].label}
          </BreadcrumbLink>
        </BreadcrumbItem>
        {(currentStep === 9 || currentStep === 10) && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink className="text-lg font-semibold text-darkPurple hover:text-darkerPurple cursor-pointer ease-in-out duration-150 transition-colors">
                Edit
              </BreadcrumbLink>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </div>
  );
};

export default ManufacturerFormBreadcrumb;
